import { CompanyAPI } from '@api';

const getMultaList = async () => CompanyAPI.getMultaList()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getMultaList };
